import K from "utilities/constants";
import {
  convertIntoDashUSFormat,
  convertIntoUtcLocalTime,
} from "utilities/dateUtility";
import { checkNullPlaceHolder } from "utilities/generalUtility";
import { displayDollar } from "utilities/tableUtility";
import { DefaultColumnOptions } from "hooks/useDataGrid/options";

export const isManualHeaderProperties = {
  checkboxSelection: true,
  headerCheckboxSelection: true,
  filter: "agSetColumnFilter",
  sortable: false,
  cellRenderer: (params) => params.value,
  valueGetter: (params) => (params.data.isManual === 1 ? "Manual" : "Auto"),
  cellClassRules: {
    "rag-red": (params) => params.value === "Auto",
    "rag-green": (params) => params.value === "Manual",
  },
  rowSelection: {
    mode: "multiRow",
  },
  filterParams: {
    values: [0, 1],
    valueFormatter: (params) => (params.value === 1 ? "Manual" : "Auto"),
  },
};
export const nullRenderer = {
  cellRenderer: (params) => checkNullPlaceHolder(params.value),
};

export const createdAtRenderer = {
  valueGetter: (params) => convertIntoDashUSFormat(params.data.createdAt),
};
export const amountRenderer = {
  valueGetter: (params) =>
    [displayDollar(+params.data.amount), `(${params.data.currency})`].join(" "),
};
export const duplicateAmountRenderer = {
  valueGetter: (params) =>
    [
      displayDollar(+params.data.duplicateAmount?.toFixed(2)),
      `(${params.data.convertToCurrency})`,
    ].join(" "),
};
export const tooltipTagRenderer = (params, key) => {
  return (
    <div className="client-list-tooltip">
      {key
        ? params.data[key].map((item) => item.name).join(" ,")
        : params.value.name}
    </div>
  );
};

export const clientBilling = [
  {
    headerName: "Auto/Manual",
    field: "isManual",
    ...isManualHeaderProperties,
  },
  { ...DefaultColumnOptions.Id, sort: "asc" },
  {
    headerName: "Billing Type",
    field: "billingTypeName",
    sortable: true,
    tooltipField: "billingTypeName",
    ...nullRenderer,
  },
  {
    headerName: "Description",
    field: "description",
    tooltipField: "description",
    sortable: true,
    ...nullRenderer,
  },
  {
    headerName: "Create Date",
    field: "createdAtDisplayValue",
    sortable: true,
    ...createdAtRenderer,
  },
  {
    headerName: "Original Amount",
    field: "amountDisplayValue",
    sortable: true,
    tooltipField: "amountDisplayValue",
  },
  {
    headerName: "Billed Amount",
    field: "duplicateAmountDisplayValue",
    sortable: true,
    tooltipField: "duplicateAmountDisplayValue",
  },
  {
    headerName: "Source",
    field: "sourceName",
    tooltipField: "sourceName",
    sortable: true,
    ...nullRenderer,
  },
  {
    headerName: "Quantity",
    field: "quantity",
    sortable: true,
    tooltipField: "quantity",
    ...nullRenderer,
  },
];

export const jobBilling = [
  {
    headerName: "Auto/Manual",
    field: "isManual",
    ...isManualHeaderProperties,
  },
  DefaultColumnOptions.Id,
  {
    headerName: "Candidate Type",
    field: "hireType",
    sortable: true,
    cellRenderer: (params) =>
      K.CandidateType[params.value] || nullRenderer.cellRenderer(params),
    tooltipValueGetter: (params) => K.CandidateType[params.value],
  },
  {
    headerName: "Billing Type",
    field: "billingTypeName",
    sortable: true,
    tooltipField: "billingTypeName",
  },
  {
    headerName: "Candidate Name",
    field: "candidateName",
    tooltipField: "candidateName",
    sortable: true,
    sort: "asc",
    ...nullRenderer,
  },
  {
    headerName: "Job Title",
    field: "jobTitle",
    sortable: true,
    tooltipField: "jobTitle",
  },
  {
    headerName: "Create Date",
    field: "createdAtDisplayValue",
    sortable: true,
    ...createdAtRenderer,
  },
  {
    headerName: "Start Date",
    field: "startDateDisplayValue",
    sortable: true,
    tooltipField: "startDateDisplayValue",
    ...nullRenderer,
  },
  {
    headerName: "Original Amount",
    field: "amountDisplayValue",
    sortable: true,
    tooltipField: "amountDisplayValue",
  },
  {
    headerName: "Billed Amount",
    field: "duplicateAmountDisplayValue",
    sortable: true,
    tooltipField: "duplicateAmountDisplayValue",
  },
  {
    headerName: "Job ATS ID",
    field: "extAtsId",
    sortable: true,
    tooltipField: "extAtsId",
    ...nullRenderer,
  },
  {
    headerName: "Job Location",
    field: "jobLocationName",
    sortable: true,
    tooltipField: "jobLocationName",
    ...nullRenderer,
  },

  {
    headerName: "Job Department",
    field: "jobDepartmentName",
    tooltipField: "jobDepartmentName",
    sortable: true,
    ...nullRenderer,
  },
  {
    headerName: "Job Group",
    field: "jobGroupName",
    sortable: true,
    tooltipField: "jobGroupName",
    ...nullRenderer,
  },
  {
    headerName: "Credit Reason",
    field: "issueCreditReason",
    sortable: true,
    tooltipField: "issueCreditReason",
    ...nullRenderer,
  },
];
